import { environment } from "environments/environment";

export const DEFAULT_LANG = 'en-GB';
export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';
export const URL_PARAM_LANG = 'lang';
export const BAVEL_PATH = {
  APP: '',
  BAVEL_COLLECT_TRAVEL: 'bavel-collect/travel',
  BAVEL_COLLECT_TRAVEL_OLD: 'travel/bavel-collect',
  BAVELPAY_TRAVEL: 'bavel-pay/travel',
  BILLBACK_RECEIVED: `${environment.urls.partnerPortal}/billback/received`,
  BILLBACK_SENT: `${environment.urls.partnerPortal}/billback/sent`,
  BILLBACK: `${environment.urls.partnerPortal}/billback`,
  BROWSERNOTSUPPORTED: 'browsernotsupported',
  AUTHENTICATIONFAILED: 'authenticationFailed',
  CREATE: 'create',
  PAYMENT_SUCCESSFUL: 'success',
  PDF_BILLING: `${environment.urls.partnerPortal}/pdf-billing`,
  WEBBILLING_TRAVEL: 'webbilling/travel',
};
export const PAYMENT_PATH = {
  APP: '',
};

export const EXTRANET_KEYS = {
  SHOW_RENOVATING_POPUP: 'show-renovating-popup'
};

export const ALERT_KEYS = {
  BAVEL_PAY_TRAVEL: {
    REFRESH_PAYMENTS: 'bavel-pay-travel-refresh-payments'
  },
  VCC: {
    OPEN_DIALOG_ERROR_CREATING_NEW_VCC: 'open-dialog-error-creating-new-vcc',
    OPEN_DIALOG_SUCCESS_CREATING_NEW_VCC: 'open-dialog-success-creating-new-vcc',
    OPEN_DIALOG_TO_CREATE_NEW_VCC: 'open-dialog-to-create-new-vcc',
    OPEN_DIALOG_TO_REVIEW_FILLED_DETAILS: 'open-dialog-to-review-filled-details',
    RESET_DATA_DIALOG_TO_CREATE_NEW_VCC: 'reset-data-dialog-to-create-new-vcc'
  },
};
